const saveReplyRoutes = {
  'monthly.bookings.messages': 'monthly.bookings.replies.new',

  'monthly.enquiries.messages': 'monthly.enquiries.replies.new',

  'monthly.booking-requests.messages': 'monthly.booking-requests.replies.new',

  'action.bookings.messages': 'action.bookings.replies.new',

  'xcalendar.bookings.messages': 'xcalendar.bookings.replies.new',
  'xcalendar.inbox.bookings.messages': 'xcalendar.inbox.bookings.replies.new',

  'xcalendar.booking-requests.messages':
    'xcalendar.booking-requests.replies.new',
  'xcalendar.inbox.booking-requests.messages':
    'xcalendar.inbox.booking-requests.replies.new',

  'xcalendar.enquiries.messages': 'xcalendar.enquiries.replies.new',
  'xcalendar.inbox.enquiries.messages': 'xcalendar.inbox.enquiries.replies.new',

  'calendar.bookings.messages': 'calendar.bookings.replies.new',

  'protection.overview.bookings.messages':
    'protection.overview.bookings.replies.new',
  'calendar.inbox.bookings.messages': 'calendar.inbox.bookings.replies.new',

  'calendar.booking-requests.messages': 'calendar.booking-requests.replies.new',
  'calendar.inbox.booking-requests.messages':
    'calendar.inbox.booking-requests.replies.new',

  'calendar.enquiries.messages': 'calendar.enquiries.replies.new',
  'calendar.inbox.enquiries.messages': 'calendar.inbox.enquiries.replies.new',
};

const editDetailsRoutes = {
  'monthly.bookings.messages': 'monthly.bookings.details',
  'monthly.bookings.summary': 'monthly.bookings.details',
  'monthly.bookings.summary.index': 'monthly.bookings.details',

  'monthly.enquiries.messages': 'monthly.enquiries.details',
  'monthly.enquiries.summary': 'monthly.enquiries.details',
  'monthly.enquiries.summary.index': 'monthly.enquiries.details',

  'monthly.booking-requests.messages': 'monthly.booking-requests.summary',
  'monthly.booking-requests.summary': 'monthly.booking-requests.summary',

  'action.bookings.messages': 'action.bookings.details',
  'action.bookings.summary': 'action.bookings.details',
  'action.bookings.summary.index': 'action.bookings.details',

  'xcalendar.bookings.messages': 'xcalendar.bookings.details',
  'xcalendar.bookings.summary': 'xcalendar.bookings.details',
  'xcalendar.bookings.summary.index': 'xcalendar.bookings.details',

  'xcalendar.inbox.bookings.messages': 'xcalendar.inbox.bookings.details',
  'xcalendar.inbox.bookings.summary': 'xcalendar.inbox.bookings.details',
  'xcalendar.inbox.bookings.summary.index': 'xcalendar.inbox.bookings.details',

  'xcalendar.booking-requests.messages': 'xcalendar.booking-requests.details',
  'xcalendar.inbox.booking-requests.messages':
    'xcalendar.inbox.booking-requests.messages',

  'xcalendar.enquiries.messages': 'xcalendar.inbox.enquiries.messages',
  'xcalendar.inbox.enquiries.messages': 'xcalendar.inbox.enquiries.messages',

  'xcalendar.bookings.price.edit': 'xcalendar.bookings.details',
  'xcalendar.bookings.price.index': 'xcalendar.bookings.details',

  'calendar.bookings.messages': 'calendar.bookings.details',
  'calendar.bookings.summary': 'calendar.bookings.details',
  'calendar.bookings.summary.index': 'calendar.bookings.details',

  'protection.overview.bookings.messages':
    'protection.overview.bookings.details',
  'protection.overview.bookings.summary':
    'protection.overview.bookings.details',
  'protection.overview.bookings.summary.index':
    'protection.overview.bookings.details',

  'calendar.inbox.bookings.messages': 'calendar.inbox.bookings.details',
  'calendar.inbox.bookings.summary': 'calendar.inbox.bookings.details',
  'calendar.inbox.bookings.summary.index': 'calendar.inbox.bookings.details',

  'calendar.booking-requests.messages': 'calendar.booking-requests.details',
  'calendar.inbox.booking-requests.messages':
    'calendar.inbox.booking-requests.messages',

  'calendar.enquiries.messages': 'calendar.inbox.enquiries.messages',
  'calendar.inbox.enquiries.messages': 'calendar.inbox.enquiries.messages',

  'calendar.bookings.price.edit': 'calendar.bookings.details',
  'calendar.bookings.price.index': 'calendar.bookings.details',

  'protection.overview.bookings.price.edit':
    'protection.overview.bookings.details',
  'protection.overview.bookings.price.index':
    'protection.overview.bookings.details',
};

const savedRepliesRoutes = {
  'monthly.bookings.messages': 'monthly.bookings.replies',
  'monthly.bookings.replies.new': 'monthly.bookings.replies',
  'monthly.bookings.replies.reply': 'monthly.bookings.replies',

  'monthly.enquiries.messages': 'monthly.enquiries.replies',
  'monthly.enquiries.replies.new': 'monthly.enquiries.replies',
  'monthly.enquiries.replies.reply': 'monthly.enquiries.replies',

  'monthly.booking-requests.messages': 'monthly.booking-requests.replies',
  'monthly.booking-requests.replies.new': 'monthly.booking-requests.replies',
  'monthly.booking-requests.replies.reply': 'monthly.booking-requests.replies',

  'action.bookings.messages': 'action.bookings.replies',
  'action.bookings.replies.new': 'action.bookings.replies',
  'action.bookings.replies.reply': 'action.bookings.replies',

  'xcalendar.bookings.messages': 'xcalendar.bookings.replies',
  'xcalendar.bookings.replies.new': 'xcalendar.bookings.replies',
  'xcalendar.bookings.replies.reply': 'xcalendar.bookings.replies',

  'xcalendar.booking-requests.messages': 'xcalendar.booking-requests.replies',
  'xcalendar.booking-requests.replies.new':
    'xcalendar.booking-requests.replies',
  'xcalendar.booking-requests.replies.reply':
    'xcalendar.booking-requests.replies',

  'xcalendar.enquiries.messages': 'xcalendar.enquiries.replies',
  'xcalendar.enquiries.replies.new': 'xcalendar.enquiries.replies',
  'xcalendar.enquiries.replies.reply': 'xcalendar.enquiries.replies',

  'xcalendar.inbox.bookings.messages': 'xcalendar.inbox.bookings.replies',
  'xcalendar.inbox.bookings.replies.new': 'xcalendar.inbox.bookings.replies',
  'xcalendar.inbox.bookings.replies.reply': 'xcalendar.inbox.bookings.replies',

  'xcalendar.inbox.booking-requests.messages':
    'xcalendar.inbox.booking-requests.replies',
  'xcalendar.inbox.booking-requests.replies.new':
    'xcalendar.inbox.booking-requests.replies',
  'xcalendar.inbox.booking-requests.replies.reply':
    'xcalendar.inbox.booking-requests.replies',

  'xcalendar.inbox.enquiries.messages': 'xcalendar.inbox.enquiries.replies',
  'xcalendar.inbox.enquiries.replies.new': 'xcalendar.inbox.enquiries.replies',
  'xcalendar.inbox.enquiries.replies.reply':
    'xcalendar.inbox.enquiries.replies',

  'calendar.bookings.messages': 'calendar.bookings.replies',
  'calendar.bookings.replies.new': 'calendar.bookings.replies',
  'calendar.bookings.replies.reply': 'calendar.bookings.replies',

  'protection.overview.bookings.messages':
    'protection.overview.bookings.replies',
  'protection.overview.bookings.replies.new':
    'protection.overview.bookings.replies',
  'protection.overview.bookings.replies.reply':
    'protection.overview.bookings.replies',

  'calendar.booking-requests.messages': 'calendar.booking-requests.replies',
  'calendar.booking-requests.replies.new': 'calendar.booking-requests.replies',
  'calendar.booking-requests.replies.reply':
    'calendar.booking-requests.replies',

  'calendar.enquiries.messages': 'calendar.enquiries.replies',
  'calendar.enquiries.replies.new': 'calendar.enquiries.replies',
  'calendar.enquiries.replies.reply': 'calendar.enquiries.replies',

  'calendar.inbox.bookings.messages': 'calendar.inbox.bookings.replies',
  'calendar.inbox.bookings.replies.new': 'calendar.inbox.bookings.replies',
  'calendar.inbox.bookings.replies.reply': 'calendar.inbox.bookings.replies',

  'calendar.inbox.booking-requests.messages':
    'calendar.inbox.booking-requests.replies',
  'calendar.inbox.booking-requests.replies.new':
    'calendar.inbox.booking-requests.replies',
  'calendar.inbox.booking-requests.replies.reply':
    'calendar.inbox.booking-requests.replies',

  'calendar.inbox.enquiries.messages': 'calendar.inbox.enquiries.replies',
  'calendar.inbox.enquiries.replies.new': 'calendar.inbox.enquiries.replies',
  'calendar.inbox.enquiries.replies.reply': 'calendar.inbox.enquiries.replies',
};

const messagesRoutes = {
  'monthly.bookings.replies.index': 'monthly.bookings.messages',
  'monthly.enquiries.replies.index': 'monthly.enquiries.messages',

  'monthly.booking-requests.replies.index': 'monthly.booking-requests.messages',

  'action.bookings.replies.index': 'action.bookings.messages',

  'xcalendar.bookings.replies.index': 'xcalendar.bookings.messages',
  'xcalendar.inbox.bookings.replies.index': 'xcalendar.inbox.bookings.messages',

  'xcalendar.booking-requests.replies.index':
    'xcalendar.booking-requests.messages',
  'xcalendar.inbox.booking-requests.replies.index':
    'xcalendar.inbox.booking-requests.messages',

  'xcalendar.enquiries.replies.index': 'xcalendar.enquiries.messages',
  'xcalendar.inbox.enquiries.replies.index':
    'xcalendar.inbox.enquiries.messages',

  'calendar.bookings.replies.index': 'calendar.bookings.messages',

  'protection.overview.bookings.replies.index':
    'protection.overview.bookings.messages',
  'calendar.inbox.bookings.replies.index': 'calendar.inbox.bookings.messages',

  'calendar.booking-requests.replies.index':
    'calendar.booking-requests.messages',
  'calendar.inbox.booking-requests.replies.index':
    'calendar.inbox.booking-requests.messages',

  'calendar.enquiries.replies.index': 'calendar.enquiries.messages',
  'calendar.inbox.enquiries.replies.index': 'calendar.inbox.enquiries.messages',
};

const repliesNewRoutes = {
  'monthly.bookings.replies.index': 'monthly.bookings.replies.new',
  'monthly.enquiries.replies.index': 'monthly.enquiries.replies.new',

  'monthly.booking-requests.replies.index':
    'monthly.booking-requests.replies.new',

  'action.bookings.replies.index': 'action.bookings.replies.new',

  'xcalendar.bookings.replies.index': 'xcalendar.bookings.replies.new',
  'xcalendar.inbox.bookings.replies.index':
    'xcalendar.inbox.bookings.replies.new',

  'xcalendar.booking-requests.replies.index':
    'xcalendar.booking-requests.replies.new',
  'xcalendar.inbox.booking-requests.replies.index':
    'xcalendar.inbox.booking-requests.replies.new',

  'xcalendar.enquiries.replies.index': 'xcalendar.enquiries.replies.new',
  'xcalendar.inbox.enquiries.replies.index':
    'xcalendar.inbox.enquiries.replies.new',

  'calendar.bookings.replies.index': 'calendar.bookings.replies.new',

  'protection.overview.bookings.replies.index':
    'protection.overview.bookings.replies.new',
  'calendar.inbox.bookings.replies.index':
    'calendar.inbox.bookings.replies.new',

  'calendar.booking-requests.replies.index':
    'calendar.booking-requests.replies.new',
  'calendar.inbox.booking-requests.replies.index':
    'calendar.inbox.booking-requests.replies.new',

  'calendar.enquiries.replies.index': 'calendar.enquiries.replies.new',
  'calendar.inbox.enquiries.replies.index':
    'calendar.inbox.enquiries.replies.new',
};

const repliesReplyRoutes = {
  'monthly.bookings.replies.index': 'monthly.bookings.replies.reply',
  'monthly.enquiries.replies.index': 'monthly.enquiries.replies.reply',

  'monthly.booking-requests.replies.index':
    'monthly.booking-requests.replies.reply',

  'action.bookings.replies.index': 'action.bookings.replies.reply',

  'xcalendar.bookings.replies.index': 'xcalendar.bookings.replies.reply',
  'xcalendar.inbox.bookings.replies.index':
    'xcalendar.inbox.bookings.replies.reply',

  'xcalendar.inbox.booking-requests.replies.index':
    'xcalendar.inbox.booking-requests.replies.reply',
  'xcalendar.booking-requests.replies.index':
    'xcalendar.booking-requests.replies.reply',

  'xcalendar.enquiries.replies.index': 'xcalendar.enquiries.replies.reply',
  'xcalendar.inbox.enquiries.replies.index':
    'xcalendar.inbox.enquiries.replies.reply',

  'calendar.bookings.replies.index': 'calendar.bookings.replies.reply',

  'protection.overview.bookings.replies.index':
    'protection.overview.bookings.replies.reply',
  'calendar.inbox.bookings.replies.index':
    'calendar.inbox.bookings.replies.reply',

  'calendar.inbox.booking-requests.replies.index':
    'calendar.inbox.booking-requests.replies.reply',
  'calendar.booking-requests.replies.index':
    'calendar.booking-requests.replies.reply',

  'calendar.enquiries.replies.index': 'calendar.enquiries.replies.reply',
  'calendar.inbox.enquiries.replies.index':
    'calendar.inbox.enquiries.replies.reply',
};

const sendMessageRoutes = {
  'monthly.bookings.summary': 'monthly.bookings.messages',
  'monthly.bookings.summary.index': 'monthly.bookings.messages',

  'monthly.booking-requests.summary': 'monthly.booking-requests.messages',

  'action.bookings.summary': 'action.bookings.messages',
  'action.bookings.summary.index': 'action.bookings.messages',

  'xcalendar.bookings.summary': 'xcalendar.bookings.messages',
  'xcalendar.bookings.summary.index': 'xcalendar.bookings.messages',

  'xcalendar.inbox.bookings.summary': 'xcalendar.inbox.bookings.messages',
  'xcalendar.inbox.bookings.summary.index': 'xcalendar.inbox.bookings.messages',

  'calendar.bookings.summary': 'calendar.bookings.messages',
  'calendar.bookings.summary.index': 'calendar.bookings.messages',

  'protection.overview.bookings.summary':
    'protection.overview.bookings.messages',
  'protection.overview.bookings.summary.index':
    'protection.overview.bookings.messages',

  'calendar.inbox.bookings.summary': 'calendar.inbox.bookings.messages',
  'calendar.inbox.bookings.summary.index': 'calendar.inbox.bookings.messages',
};

const summaryRoutes = {
  'monthly.booking-requests.summary': 'monthly.booking-requests.summary',

  'monthly.bookings.summary': 'monthly.bookings.summary',
  'monthly.bookings.summary.index': 'monthly.bookings.summary',
  'monthly.bookings.summary.modify': 'monthly.bookings.summary',
  'monthly.bookings.summary.accept': 'monthly.bookings.summary',

  'action.bookings.summary': 'action.bookings.summary',
  'action.bookings.summary.index': 'action.bookings.summary',
  'action.bookings.summary.modify': 'action.bookings.summary',
  'action.bookings.summary.accept': 'action.bookings.summary',

  'xcalendar.bookings.summary': 'xcalendar.bookings.summary',
  'xcalendar.bookings.summary.index': 'xcalendar.bookings.summary',
  'xcalendar.bookings.summary.modify': 'xcalendar.bookings.summary',
  'xcalendar.bookings.summary.accept': 'xcalendar.bookings.summary',

  'xcalendar.inbox.bookings.summary': 'xcalendar.inbox.bookings.summary',
  'xcalendar.inbox.bookings.summary.index': 'xcalendar.inbox.bookings.summary',
  'xcalendar.inbox.bookings.summary.modify': 'xcalendar.inbox.bookings.summary',
  'xcalendar.inbox.bookings.summary.accept': 'xcalendar.inbox.bookings.summary',

  'calendar.bookings.summary': 'calendar.bookings.summary',
  'calendar.bookings.summary.index': 'calendar.bookings.summary',
  'calendar.bookings.summary.modify': 'calendar.bookings.summary',
  'calendar.bookings.summary.accept': 'calendar.bookings.summary',

  'protection.overview.bookings.summary':
    'protection.overview.bookings.summary',
  'protection.overview.bookings.summary.index':
    'protection.overview.bookings.summary',
  'protection.overview.bookings.summary.modify':
    'protection.overview.bookings.summary',
  'protection.overview.bookings.summary.accept':
    'protection.overview.bookings.summary',

  'calendar.inbox.bookings.summary': 'calendar.inbox.bookings.summary',
  'calendar.inbox.bookings.summary.index': 'calendar.inbox.bookings.summary',
  'calendar.inbox.bookings.summary.modify': 'calendar.inbox.bookings.summary',
  'calendar.inbox.bookings.summary.accept': 'calendar.inbox.bookings.summary',
};

const cancelPriceEditRoutes = {
  'action.bookings.price.edit': 'action.bookings.price',

  'monthly.bookings.price.edit': 'monthly.bookings.price',

  'xcalendar.bookings.price.edit': 'xcalendar.bookings.price',

  'xcalendar.inbox.bookings.price.edit': 'xcalendar.inbox.bookings.price',

  'calendar.bookings.price.edit': 'calendar.bookings.price',

  'protection.overview.bookings.price.edit':
    'protection.overview.bookings.price',

  'calendar.inbox.bookings.price.edit': 'calendar.inbox.bookings.price',
};

const editPriceRoutes = {
  'action.bookings.price': 'action.bookings.price.edit',
  'action.bookings.price.edit': 'action.bookings.price.edit',
  'action.bookings.price.index': 'action.bookings.price.edit',

  'monthly.bookings.price': 'monthly.bookings.price.edit',
  'monthly.bookings.price.edit': 'monthly.bookings.price.edit',
  'monthly.bookings.price.index': 'monthly.bookings.price.edit',

  'xcalendar.bookings.price': 'xcalendar.bookings.price.edit',
  'xcalendar.bookings.price.edit': 'xcalendar.bookings.price.edit',
  'xcalendar.bookings.price.index': 'xcalendar.bookings.price.edit',

  'xcalendar.inbox.bookings.price': 'xcalendar.inbox.bookings.price.edit',
  'xcalendar.inbox.bookings.price.edit': 'xcalendar.inbox.bookings.price.edit',
  'xcalendar.inbox.bookings.price.index': 'xcalendar.inbox.bookings.price.edit',

  'calendar.bookings.price': 'calendar.bookings.price.edit',
  'calendar.bookings.price.edit': 'calendar.bookings.price.edit',
  'calendar.bookings.price.index': 'calendar.bookings.price.edit',

  'protection.overview.bookings.price':
    'protection.overview.bookings.price.edit',
  'protection.overview.bookings.price.edit':
    'protection.overview.bookings.price.edit',
  'protection.overview.bookings.price.index':
    'protection.overview.bookings.price.edit',

  'calendar.inbox.bookings.price': 'calendar.inbox.bookings.price.edit',
  'calendar.inbox.bookings.price.edit': 'calendar.inbox.bookings.price.edit',
  'calendar.inbox.bookings.price.index': 'calendar.inbox.bookings.price.edit',
};

const hostRoutes = {
  'action.changeovers.summary': 'action.changeovers.host',
  'monthly.changeovers.summary': 'monthly.changeovers.host',
  'xcalendar.changeovers.summary': 'xcalendar.changeovers.host',
  'calendar.changeovers.summary': 'calendar.changeovers.host',
};

export const getBookingPanelBaseRouteFor = (route: string): string => {
  if (route.startsWith('action')) {
    return 'action';
  }

  if (route.startsWith('protection')) {
    return 'protection.overview';
  }

  let base = 'calendar';

  if (route.startsWith('xcalendar')) {
    base = 'xcalendar';
  } else if (route.includes('monthly')) {
    base = 'monthly';
  }

  return route.includes('inbox') ? `${base}.inbox` : base;
};

const getRouteFor = (routes: Record<string, string>, route: string) => {
  return routes[route as keyof typeof routes] ?? '';
};

export const getSaveReplyRouteFor = (route: string) =>
  getRouteFor(saveReplyRoutes, route);

export const getEditDetailsRouteFor = (route: string) =>
  getRouteFor(editDetailsRoutes, route);

export const getSavedRepliesRouteFor = (route: string) =>
  getRouteFor(savedRepliesRoutes, route);

export const getMessagesRouteFor = (route: string) =>
  getRouteFor(messagesRoutes, route);

export const getRepliesNewRouteFor = (route: string) =>
  getRouteFor(repliesNewRoutes, route);

export const getRepliesReplyRouteFor = (route: string) =>
  getRouteFor(repliesReplyRoutes, route);

export const getSendMessageRouteFor = (route: string) =>
  getRouteFor(sendMessageRoutes, route);

export const getSummaryRouteFor = (route: string) =>
  getRouteFor(summaryRoutes, route);

export const getCancelPriceEditRouteFor = (route: string) =>
  getRouteFor(cancelPriceEditRoutes, route);

export const getEditPriceRouteFor = (route: string) =>
  getRouteFor(editPriceRoutes, route);

export const getHostRouteFor = (route: string) =>
  getRouteFor(hostRoutes, route);
